import type { RouteRecordRaw } from 'vue-router';

// Import page components from views
import Reports from '../views/Reports.vue';
import ReportOverview from '../views/ReportOverview.vue';
import ReportGrade from '../views/ReportGrade.vue';
import ReportGateway from '../views/ReportGateway.vue';
import ReportCompare from '../views/ReportCompare.vue';

// Define application routes
export const routes: RouteRecordRaw[] = [
  {
    path: '/reports',
    name: 'reports',
    component: Reports,
    props: (route) => ({
      formats: route.query.formats
        ? Array.isArray(route.query.formats)
          ? route.query.formats
          : [route.query.formats]
        : [],
      grades: route.query.grades
        ? Array.isArray(route.query.grades)
          ? route.query.grades
          : [route.query.grades]
        : [],
      alignment: route.query.alignment
        ? Array.isArray(route.query.alignment)
          ? route.query.alignment
          : [route.query.alignment]
        : [],
      usability: route.query.usability
        ? Array.isArray(route.query.usability)
          ? route.query.usability
          : [route.query.usability]
        : [],
      versions: route.query.versions
        ? Array.isArray(route.query.versions)
          ? route.query.versions
          : [route.query.versions]
        : [],
      publishers: route.query.publishers
        ? Array.isArray(route.query.publishers)
          ? route.query.publishers
          : [route.query.publishers]
        : [],
      supportingDocuments: route.query.supportingDocuments
        ? Array.isArray(route.query.supportingDocuments)
          ? route.query.supportingDocuments
          : [route.query.supportingDocuments]
        : [],
      page: route.query.p ? parseInt(route.query.p as string) || 1 : 1,
      order: route.query.order as string,
      dir: route.query.dir as string,
      search: route.query.search as string,
    }),
  },
  {
    path: '/reports/:subject',
    name: 'reports-subject',
    component: Reports,
    props: (route) => ({
      subject: route.params.subject,
      formats: route.query.formats
        ? Array.isArray(route.query.formats)
          ? route.query.formats
          : [route.query.formats]
        : [],
      grades: route.query.grades
        ? Array.isArray(route.query.grades)
          ? route.query.grades
          : [route.query.grades]
        : [],
      alignment: route.query.alignment
        ? Array.isArray(route.query.alignment)
          ? route.query.alignment
          : [route.query.alignment]
        : [],
      usability: route.query.usability
        ? Array.isArray(route.query.usability)
          ? route.query.usability
          : [route.query.usability]
        : [],
      versions: route.query.versions
        ? Array.isArray(route.query.versions)
          ? route.query.versions
          : [route.query.versions]
        : [],
      publishers: route.query.publishers
        ? Array.isArray(route.query.publishers)
          ? route.query.publishers
          : [route.query.publishers]
        : [],
      supportingDocuments: route.query.supportingDocuments
        ? Array.isArray(route.query.supportingDocuments)
          ? route.query.supportingDocuments
          : [route.query.supportingDocuments]
        : [],
      page: route.query.p ? parseInt(route.query.p as string) || 1 : 1,
      order: route.query.order as string,
      dir: route.query.dir as string,
      search: route.query.search as string,
    }),
  },
  {
    path: '/reports/overview/:id',
    name: 'report-overview',
    component: ReportOverview,
  },
  // Redirect from /reports/detail/{series_slug} to /reports/overview/{series_slug}
  {
    path: '/reports/detail/:id',
    redirect: (to) => {
      return `/reports/overview/${to.params.id}`;
    },
  },
  {
    path: '/reports/detail/:id/:grade',
    name: 'report-grade-overview',
    component: ReportGrade,
  },
  {
    path: '/reports/detail/:id/:grade/:gateway',
    name: 'report-gateway',
    component: ReportGateway,
  },
  // Compare route temporarily removed
  // {
  //   path: '/reports/compare',
  //   name: 'report-compare',
  //   component: ReportCompare,
  // },
];
